import { render, staticRenderFns } from "./devList.vue?vue&type=template&id=2f45ec79&scoped=true&"
import script from "./devList.vue?vue&type=script&lang=js&"
export * from "./devList.vue?vue&type=script&lang=js&"
import style0 from "./devList.vue?vue&type=style&index=0&id=2f45ec79&scoped=true&lang=css&"
import style1 from "./devList.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45ec79",
  null
  
)

export default component.exports